import { PaymentStatus } from '@/api/payment/payment.types';
import { ApiResponse } from '@/api/shared.types';
import axiosServer from '@/services/axios';
import { transformToApiError } from '@/utils/error.ts';

const endpoint = '/payment';

export const getTransactionStatus = async (
  transactionId: string
): Promise<ApiResponse<{ status: PaymentStatus }>> => {
  try {
    const response = await axiosServer.get(
      `${endpoint}/transaction/${transactionId}/status`
    );
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
